import React from 'react';
import { useAttributeFormBuilder } from '../../../../Hooks/Display/useComponentProperties';
import { useSelectedComponent } from '../../../../Hooks/Display/useComponents';
import ColumnColorFormatting from './ColumnColorFormatting';
import { useTranslation } from 'react-i18next';

const ColumnHeader = ({ column }) => {

    const { t } = useTranslation([
        "display/components/form"
    ]);

    const [, dispatch] = useAttributeFormBuilder();
    const selectedComponent = useSelectedComponent();
    const shouldColumnColorFormatting = selectedComponent.componentType === "View"
    const shouldShowEditColumnForComponentType = ["Cards", "View", "Form"].includes(selectedComponent.componentType);
    const shouldShowEditColumnButton = shouldShowEditColumnForComponentType

    const handleRemoveColumn = () => {
        dispatch.removeColumn(column.attributeId);
    };

    const handleEditColumn = () => {
        dispatch.setEditingColumn(column);
        dispatch.toggleEditColumnPanel();
    };

    return (
        <div className='d-flex justify-content-end'>
            {/* {shouldColumnColorFormatting && <ColumnColorFormatting column={column} />} */}
            {shouldShowEditColumnButton && (
                <button
                    title={t("column.title.edit_column", { ns: "display/components/form" })}
                    className='btn btn-sm btn-link non-draggable'
                    onClick={handleEditColumn}
                >
                    <i className="fa-regular fa-pen text-primary"></i>
                </button>
            )}
            <button
                title={t("column.title.remove_column", { ns: "display/components/form" })}
                className='btn btn-sm btn-link non-draggable'
                onClick={handleRemoveColumn}
            >
                <i className="fa-regular fa-trash text-danger"></i>
            </button>
        </div>
    );
};

export default ColumnHeader;